<div>
  <p class="tw-text-xl tw-font-bold tw-my-4">TOP BRANDS</p>
  <div class="tw-gap-4 tw-overflow-x-auto tw-flex">
    <div (click)="onBrandClick(brand)" class="tw-cursor-pointer tw-flex-shrink-0 tw-w-52 tw-p-4 tw-bg-grayLight" *ngFor="let brand of brands">
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
        <img class="tw-h-12" [src]="brand.icon" alt="">
        <br>
        <p class="tw-mb-0"><b>{{brand.name | uppercase}}</b></p>
      </div>
    </div>
  </div>
</div>